(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Horizon's own hover-preview (previewImage/resetImage in product-card.js) only
  // undoes a single hover-triggered slide advance. A card whose arrows were
  // clicked manually stays stuck on whatever slide was last shown once the
  // pointer leaves, because a real arrow click is a permanent navigation, not
  // a temporary hover peek. This is a card-gallery-only safety net: it always
  // returns a card to its first slide and releases any lingering focus once
  // the pointer actually leaves it, regardless of how the slide got there.
  // Deliberately scoped to `.card-gallery` rather than the shared
  // slideshow-component so nothing else in the theme (product page galleries,
  // homepage sliders, etc.) is affected.
  document.addEventListener(
    'pointerleave',
    (event) => {
      const gallery = event.target instanceof Element ? event.target.closest('.card-gallery') : null;
      if (!gallery) return;

      gallery.querySelectorAll('slideshow-component').forEach((slideshow) => {
        if (typeof slideshow.select === 'function' && slideshow.current !== 0) {
          slideshow.select(0, undefined, { animate: false });
        }
      });

      if (document.activeElement instanceof HTMLElement && gallery.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
